(() => {
  const selector = '[data-jj-lazy-autoplay-video]';

  const initVideo = (video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.jjLazyVideoReady === 'true') return;
    video.dataset.jjLazyVideoReady = 'true';
    video.muted = true;
    video.playsInline = true;
    video.preload = 'none';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    if (!('IntersectionObserver' in window)) {
      video.preload = 'metadata';
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target !== video) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          if (video.preload === 'none') video.preload = 'metadata';
          video.play().catch(() => {});
        } else if (!entry.isIntersecting || entry.intersectionRatio < 0.08) {
          video.pause();
        }
      });
    }, {
      rootMargin: '120px 0px',
      threshold: [0, 0.08, 0.2, 0.5]
    });

    observer.observe(video);
  };

  const init = (root = document) => root.querySelectorAll?.(selector).forEach(initVideo);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
